import React from "react";
import { Link } from "react-router-dom";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import ThemeToggle from "@/components/ThemeToggle";
import { SetuMark } from "@/components/Logo";

export default function LegalLayout({ title, updated, children }) {
  const displayDate = updated || new Date().toLocaleDateString("en-IN", {
    day: "2-digit", month: "long", year: "numeric"
  });
  return (
    <div className="min-h-screen">
      <header className="border-b border-border bg-card sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-logo">
            <div className="w-8 h-8 rounded-md bg-primary grid place-items-center text-primary-foreground"><SetuMark size={22} strokeWidth={2.6} /></div>
            <span className="font-heading text-lg tracking-tight">Setubuild.OS</span>
          </Link>
          <div className="flex items-center gap-2">
            <LanguageSwitcher /><ThemeToggle />
          </div>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 md:px-8 py-12">
        <h1 className="font-display text-5xl mt-1">{title}</h1>
        <div className="mono text-xs text-muted-foreground mt-2">Last updated: {displayDate}</div>
        <article className="mt-8 space-y-6 text-sm leading-relaxed">
          {children}
        </article>
        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-border pt-6">
          <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">© {new Date().getFullYear()} SetuBuild Technologies. All rights reserved.</div>
          <div className="flex gap-4 mono text-[10px] uppercase tracking-widest">
            <Link to="/about" className="hover:text-primary">About</Link>
            <Link to="/contact" className="hover:text-primary">Contact</Link>
            <Link to="/faq" className="hover:text-primary">FAQ</Link>
            <Link to="/privacy" className="hover:text-primary">Privacy</Link>
            <Link to="/terms" className="hover:text-primary">Terms</Link>
            <Link to="/refund" className="hover:text-primary">Refund</Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="font-heading text-2xl">{title}</h2>
    <div className="text-muted-foreground">{children}</div>
  </section>
);
